module.exports = __webpack_public_path__ + "static/go-mobile@3x-b879ad33b4260e05dddd6940769ad1d6.png";